import { RepeatableRequestManager } from '@cian/valuation-utils-component';

export let UpdateLegalCheckService: RepeatableRequestManager;

export const init = () => {
  UpdateLegalCheckService = new RepeatableRequestManager();
};
